<template>
  <span v-if="showMonthlyPriceInfo" data-testid="monthly-price"
    >(Monthly price £{{ Number(formattedPricePerMonth).toFixed(2) }})
    <InfoBubble
      text="The monthly payment is calculated by dividing the weekly cost by 7 (days),
multiplying by the number of days in the year, and dividing by 12 (months).
Part months are calculated for the number of days at the daily rate."
    />
  </span>
</template>
<script>
import InfoBubble from "@/components/InfoBubble.vue";
import { mapGetters } from "vuex";

export default {
  name: "MonthlyPriceInfo",
  components: {
    InfoBubble,
  },
  computed: {
    ...mapGetters({
      formattedPricePerMonth: "formattedPricePerMonth",
      showMonthlyPriceInfo: "getShowMonthlyPriceInfo",
    }),
  },
};
</script>
